import { Label, Tab, Table, TableRow, TableRowDisplayEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutOrderPlanningUnseatedTractor } from "./autogen/AutogenLayoutOrderPlanningUnseatedTractor";
import { LogManager, ModelRow } from "@mcleod/core";
import { PlanningUtil } from "./PlanningUtil";
import { CommonTooltips } from "@mcleod/common";
import { OrderPlanningToolPanel } from "./OrderPlanningToolPanel";

const log = LogManager.getLogger("lme.dispatch.OrderPlanningUnseatedTractor");

export class OrderPlanningUnseatedTractor extends AutogenLayoutOrderPlanningUnseatedTractor {
    public caption: string;
    private _toolsPanel: OrderPlanningToolPanel;
    private tab: Tab;

    async onLoad() {
        this.tableUnseatedTractor.dataSource.orderBy = [{field: "time_since_dispatched", sort: "desc"}];
    }

    public updateCounts(tab: Tab) {
        this.tab = tab;
        log.debug("OrderPlanningUnseated Tractor updateCounts() called");
        tab.caption = `${this.caption} ${this.sourceUnseatedTractor.data.length}`;
    }

    getTab() {
        return this.tab;
    }

    public getTable(): Table {
        return this.tableUnseatedTractor;
    }

    tableOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow: TableRow = event.getTableRow();
        this.setUpDispatchLabel(tableRow);
        this.setupTractor(tableRow);
        PlanningUtil.setupTractorComments(tableRow);
    }

    private setUpDispatchLabel(tableRow: TableRow){
        const modelRow = tableRow.data as ModelRow;
        const textboxTimeSinceDispatch = tableRow.findComponentById("labelTimeSinceDispatch") as Label;
        const hoursSinceDelivered: number = modelRow.get("time_since_dispatched", null);
        PlanningUtil.configureTimeSinceDelivered(textboxTimeSinceDispatch, hoursSinceDelivered);
    }

    private setupTractor(tableRow: TableRow){
        const modelRow = tableRow.data as ModelRow;
        const textboxTractor = tableRow.findComponentById("textboxTractorId") as Textbox;
        CommonTooltips.setTooltipContentLayout(textboxTractor, modelRow.get("tractor.id"), "lme/dispatch/asset/TractorQuickInfo", { minWidth: 128, minHeight: 140 });
    }

    textboxPlanningCommentOnChange(event) {
        PlanningUtil.textboxPlanningCommentOnChangeListener(event);
    }
}
